"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAreFavoritesEnabled = void 0;
/** @deprecated Favorite button is now always visible */
const useAreFavoritesEnabled = ({
  customerId
} = {}) => true;
exports.useAreFavoritesEnabled = useAreFavoritesEnabled;
